import { TranslationKeyMap } from '../event-centre-dialog.i18n';

import { Status } from './status.model';

export const StatusLabels = [
    { status: Status.READ, label: TranslationKeyMap._11148_READ },
    { status: Status.UNREAD, label: TranslationKeyMap._11147_UNREAD },
    { status: Status.DELETED, label: TranslationKeyMap._9496_DELETED },
];
